import { objSafeProps } from 'utils';

export const form = ({
  title,
  fields,
  fieldsValues,
  submitTitle,
  cancelTitle,
  validations,
  validationErrors,
  isCancel,
  isActionButtons,
  onCancel,
  onSubmit,
  onChange,
  onProps, // fieldsValues with updated values
  changeFields, // [{name = '', props = {}}]
  style,
  onlyFieldsValue,
  validateOnBlur,
}) => objSafeProps({
  title,
  fields,
  fieldsValues,
  submitTitle,
  cancelTitle,
  validations,
  validationErrors,
  isCancel,
  isActionButtons,
  onCancel,
  onSubmit,
  onChange,
  onProps,
  changeFields,
  style,
  onlyFieldsValue,
  validateOnBlur,
});
